/*
 * @Author: Teemo Ding
 * @Date: 2021-05-26 15:57:06
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-17 16:45:28
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/SalesChannelCollectionConfig.tsx
 */
import React from 'react';
import TagGroup from 'src/components/TagGroup/TagGroup';
import WarningPopReminder from 'src/constrains/PopReminder/Warning';
import css from './css.module.less';
const breadcrumbData = (name, { getI18n }) => [
  {
    url: '',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/salesChannels',
    name: getI18n('general.sider.salesChannel'),
  },
  {
    url: '',
    name: name,
  },
  {
    url: '',
    name: getI18n('productCollection.index.productCollection'),
  },
];
const sortList = ({ getI18n }) => [
  //排序下拉列表配置
  {
    name: getI18n('productCollection.index.modifiednewest'),
    key: 1,
    data: 'CreatedDateDesc',
  },
  {
    name: getI18n('productCollection.index.modifiedoldest'),
    key: 2,
    data: 'CreatedDateAsc',
  },
  {
    name: getI18n('productCollection.index.collectionnameAZ'),
    key: 3,
    data: 'CollectionNameAsc',
  },
  {
    name: getI18n('productCollection.index.collectionnameZA'),
    key: 4,
    data: 'CollectionNameDesc',
  },
];

const productsColumns = (deleteFun, isPrimary, { getI18n }) =>
  isPrimary
    ? [
        {
          title: '',
          dataIndex: 'thumbnailUrl',
          key: 'thumbnailImageUrl',
          default: true,
          optional: false,
          className: css.columnClass,
          render: (url, record) => {
            return (
              <img
                width={40}
                height={40}
                key={record.thumbnailUrl || record.thumbnailImageUrl}
                src={record.thumbnailUrl || record.thumbnailImageUrl}
                alt={record.thumbnailUrl || record.thumbnailImageUrl}
              />
            );
          },
          width: 56,
        },

        {
          title: getI18n('general.productName'),
          dataIndex: 'productName',
          default: true,
          optional: true,
          key: 'productName',
          className: css.columnClass,
          minWidth: 236,
        },
        {
          title: getI18n('general.type'),
          dataIndex: 'alias',
          default: true,
          optional: true,
          key: 'alias',
          className: css.columnClass,
          minWidth: 70,
          render: (text, record) =>
            text === true
              ? getI18n('general.alias')
              : getI18n('general.original'),
        },
        {
          title: getI18n('general.remarks'),
          dataIndex: 'remarks',
          default: true,
          optional: true,
          key: 'remarks',
          className: css.columnClass,
          minWidth: 120,
        },

        {
          title: getI18n('general.tags'),
          dataIndex: 'tags',
          default: true,
          optional: true,
          align: 'center',
          className: css.columnClass,
          key: 'tags',
          minWidth: 200,
          tags: true,
          tagsGenerator: (
            characterLength,
            width,
            marginPaddingWidth,
            containPaddingWidth,
            tags,
            record,
          ) => {
            return (
              <TagGroup
                characterLength={characterLength}
                containerWidth={width}
                marginPaddingWidth={marginPaddingWidth}
                containPaddingWidth={containPaddingWidth}
                tags={tags}
              />
            );
          },
        },
        {
          title: getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
          dataIndex: 'remarks',
          default: true,
          optional: true,
          key: 'remarks',
          className: css.columnClass,
          minWidth: 120,
          render: (text, record) => (
            <WarningPopReminder
              title={getI18n('productCollection.index.removeProduct')}
              content={getI18n('productCollection.index.removeProductContent')}
              onOkText={getI18n('general.remove')}
              onOk={() => {
                deleteFun([record.uuid]);
              }}>
              <a href='#' className={css.errorText}>
                {getI18n('general.remove')}
              </a>
            </WarningPopReminder>
          ),
        },
      ]
    : [
        {
          title: '',
          dataIndex: 'thumbnailUrl',
          key: 'thumbnailUrl',
          default: true,
          optional: false,
          className: css.columnClass,
          render: (url, record) => {
            return (
              <img
                width={40}
                height={40}
                key={record.thumbnailUrl || record.thumbnailImageUrl}
                src={record.thumbnailUrl || record.thumbnailImageUrl}
                alt={record.thumbnailUrl || record.thumbnailImageUrl}
              />
            );
          },
          width: 56,
        },

        {
          title: getI18n('general.productName'),
          dataIndex: 'productName',
          default: true,
          optional: true,
          key: 'productName',
          className: css.columnClass,
          minWidth: 300,
        },
        {
          title: getI18n('general.type'),
          dataIndex: 'alias',
          default: true,
          optional: true,
          key: 'alias',
          className: css.columnClass,
          minWidth: 100,
          render: (text, record) =>
            text === true
              ? getI18n('general.alias')
              : getI18n('general.original'),
        },
        {
          title: getI18n('general.remarks'),
          dataIndex: 'remarks',
          default: true,
          optional: true,
          key: 'remarks',
          className: css.columnClass,
          minWidth: 300,
        },
      ];

const buttonMenu = (duplicateFun, deleteFun, { getI18n }) => [
  {
    key: 2,
    value: getI18n('general.duplicate'),
    function: duplicateFun,
  },
  {
    key: 3,
    value: getI18n('general.delete'),
    color: '#DD4A3A',
    function: deleteFun,
  },
];
export { breadcrumbData, buttonMenu, productsColumns, sortList };
